<template>
  <span :class="'icon ' + containerClass">
    <i :class="name" />
  </span>
</template>

<script>
export default {
  name: 'PbcIcon',
  props: {
    name: {
      type: String,
      required: true,
    },
    containerClass: {
      type: String,
      required: false,
      default: '',
    },
  },
};
</script>
